import React from "react";

type Props = {
  elementId: string;
  label: string;
  options: string[];
  selectedVal: string;
  onChange: (val: string) => void;
  disabled?: boolean;
};

const DropDown: React.FC<Props> = ({
  elementId,
  label,
  options,
  selectedVal,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="fu-dropdown">
      <label className="fu-dropdown-label" htmlFor={elementId}>
        {label}
      </label>

      <select
        id={elementId}
        className="fu-dropdown-select"
        value={selectedVal}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDown;